// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2F0i4","footer":"ModalUpdate_footer__24DMS"};